import { BUSINESS } from "@/data/business";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const links = [
    { label: "Services", id: "#services" },
    { label: "Work", id: "#work" },
    { label: "Why Us", id: "#why" },
    { label: "Contact", id: "#contact" },
  ];

  return (
    <nav
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-2xl bg-[#050505]/80 border-b border-[#222222]"
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("#hero")}
          className="flex items-center gap-3 group"
        >
          <span className="w-2.5 h-2.5 bg-[#FF3B30] block group-hover:scale-150 transition-transform duration-300" />
          <span className="font-display font-bold text-white uppercase tracking-tight text-sm md:text-base">
            Manasa <span className="text-[#555555]">Consumer Electronics</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => scrollTo(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-[#A0A0A0] hover:text-white transition-colors font-mono-plex"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-cta"
          onClick={() => scrollTo("#contact")}
          className="bg-[#FF3B30] text-white px-5 md:px-8 py-3 uppercase tracking-[0.15em] text-[10px] md:text-xs font-bold transition-all hover:bg-white hover:text-black font-mono-plex"
        >
          Get a Quote
        </button>
      </div>
    </nav>
  );
};

export default Nav;
